module.exports = __webpack_public_path__ + "static/media/areas06M.4185e896.jpg";